import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Chip from '@material-ui/core/Chip';
import api from "../../services/api";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
  container: { paddingTop: theme.spacing(4), paddingBottom: theme.spacing(4) },
  title: { marginBottom: theme.spacing(3), color: '#2c3e50', fontWeight: 'bold' },
  tableContainer: { boxShadow: '0 4px 6px rgba(0,0,0,0.05)', borderRadius: '8px' },
  tableHeader: { backgroundColor: '#f4f6f9' },
  headerCell: { fontWeight: 'bold', color: '#34495e' },
  row: { '&:nth-of-type(odd)': { backgroundColor: '#fafafa' } },
  badge: { fontWeight: 'bold', fontSize: '14px' }
}));

export default function CurrentlyBeingServed() {
  const classes = useStyles();
  const [analistas, setAnalistas] = useState([]);

  const fetchDados = async () => {
    try {
      const { data } = await api.get("/currently-serving");
      setAnalistas(data);
    } catch (err) {
      toast.error("Erro ao carregar dados do painel.");
    }
  };

  useEffect(() => {
    fetchDados();
    const interval = setInterval(fetchDados, 30000);
    return () => clearInterval(interval);
  }, []);

  // Define a cor do Badge de quantidade
  const getBadgeColor = (qtd) => {
    if (qtd > 10) return 'secondary'; // Vermelho/Rosa para sobrecarregado
    if (qtd > 0) return 'primary';     // Azul para atendendo normal
    return 'default';                  // Cinza para sem tickets
  };

  // Define o texto e a cor da coluna de Status com base nos tickets atuais
  const getStatusInfo = (qtd) => {
    if (qtd > 10) return { texto: "Ocupado (Carga Alta)", cor: "#e74c3c" };
    if (qtd > 0) return { texto: "Atendendo", cor: "#2ecc71" };
    return { texto: "Disponível", cor: "#3498db" };
  };

  return (
    <Container maxWidth="lg" className={classes.container}>
      <Typography variant="h5" component="h2" className={classes.title}>
        Tickets em Atendimento por Analista (Tempo Real)
      </Typography>

      <TableContainer component={Paper} className={classes.tableContainer}>
        <Table aria-label="tabela de analistas">
          <TableHead className={classes.tableHeader}>
            <TableRow>
              <TableCell className={classes.headerCell}>Analista</TableCell>
              <TableCell align="center" className={classes.headerCell}>Status</TableCell>
              <TableCell align="center" className={classes.headerCell}>Tickets em Atendimento Agora</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {analistas.map((analista) => {
              const qtd = analista.qtdTickets || 0;
              const statusInfo = getStatusInfo(qtd);

              return (
                <TableRow key={analista.id} className={classes.row}>
                  <TableCell component="th" scope="row" style={{ fontWeight: 500 }}>
                    {analista.nome}
                  </TableCell>
                  <TableCell align="center">
                    <span style={{ color: statusInfo.cor, fontWeight: 'bold' }}>
                      {statusInfo.texto}
                    </span>
                  </TableCell>
                  <TableCell align="center">
                    <span className={classes.badge}>
                      <Chip 
                        label={qtd} 
                        color={getBadgeColor(qtd)}
                      />
                    </span>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
}